const initialState = {
    loggedInUserDetails: {},
    tennantName: {},
    setpolicy: '',
};

const loginSuccessReducer = (state = initialState, action) => {
    switch (action.type) {
        case 'SetUserDetails':
            return {
                ...state,
                loggedInUserDetails: action.payload,
            };
        case 'SetTennantName':
            return {
                ...state,
                tennantName: action.payload,
            };
        case 'setPolicy':
            return {
                ...state,
                setpolicy: action.payload,
            };
        default:
            return state;
    }
};

export default loginSuccessReducer;
